module.exports = __webpack_public_path__ + "static/media/solution-logo.baf4694f.svg";